module.exports = __webpack_public_path__ + "img/multiplayer_idle.943b30b1.png";